import { useState } from 'react';
import Field from '../Field.jsx';
import Alert from './Alert.jsx';
import Modal, { ModalActions } from './Modal.jsx';

/**
 * "Are you sure?" for anything that removes or changes access. Never window.confirm.
 *
 * onConfirm may be async; a thrown error is shown in the dialog and it stays open.
 * typeToConfirm: the user must type this exact text (e.g. an email) before confirming.
 */
export default function ConfirmModal({
  title, children, confirmLabel, cancelLabel, onConfirm, onClose, danger = false, typeToConfirm, typeLabel,
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [typed, setTyped] = useState('');
  const ready = !typeToConfirm || typed.trim().toLowerCase() === String(typeToConfirm).toLowerCase();

  const confirm = async () => {
    if (!ready) return;
    setBusy(true); setError('');
    try {
      await onConfirm(typed.trim());
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <Modal title={title} onClose={onClose} onSubmit={confirm} busy={busy} size="sm" tone={danger ? 'danger' : undefined}
      footer={<ModalActions submitLabel={confirmLabel} cancelLabel={cancelLabel} busy={busy} onCancel={onClose} danger={danger} disabled={!ready} />}>
      {error && <Alert tone="danger">{error}</Alert>}
      <div className="modal-text">{children}</div>
      {typeToConfirm && (
        <Field label={typeLabel || <>Type <strong className="mono">{typeToConfirm}</strong> to confirm</>}
          value={typed} onChange={(e) => setTyped(e.target.value)} autoComplete="off" spellCheck={false} />
      )}
    </Modal>
  );
}
